export function toUpdatableField<T>(value: T | null | undefined) {
	if (value === null) {
		return { clear: true };
	}

	if (value === undefined) {
		return undefined;
	}

	return { value, clear: false };
}
